export function camelToSnakeCase (str: string, toLowerCase = true): string {
  const _str = str.replace(/([a-z])([A-Z])/g, '$1_$2')

  return toLowerCase
    ? _str.toLowerCase()
    : _str
}

export function transformAnalyticsDataToSurvicate (
  data: Record<string, unknown> | null | undefined
): Record<string, string> | undefined {
  if (!data) return

  return Object.keys(data).reduce<Record<string, string>>((acc, key) => {
    return {
      ...acc,
      [camelToSnakeCase(key)]: String(data[key]),
    }
  }, {})
}
